/**
 * @returns {React.ReactElement}
 */
const ContentHubVideo = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 69 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_818_3002)">
      <path
        d="M60.6232 50H8.37861C4.20348 50 0.804688 46.5991 0.804688 42.4188V7.58122C0.804688 3.4009 4.20231 0 8.37861 0H60.6232C64.7984 0 68.1972 3.4009 68.1972 7.58122V42.4188C68.1972 46.5979 64.7995 50 60.6232 50ZM8.37861 2.60392C5.63689 2.60392 3.4061 4.83686 3.4061 7.58122V42.4188C3.4061 45.1631 5.63689 47.3961 8.37861 47.3961H60.6232C63.365 47.3961 65.5957 45.1631 65.5957 42.4188V7.58122C65.5957 4.83686 63.365 2.60392 60.6232 2.60392H8.37861Z"
        fill="#6B6B6B"
      />
      <path
        d="M29.5933 36.8317C28.7152 36.8317 27.8723 36.5812 27.1041 36.0862C25.6765 35.2728 24.8242 33.7713 24.8242 32.0053V17.9172C24.8242 16.225 25.6976 14.7153 27.1614 13.8774C28.5141 13.0055 30.1849 12.9212 31.7995 13.6737C31.8182 13.6831 31.8346 13.6913 31.8521 13.7006L45.314 20.7447C46.9041 21.5932 47.8476 23.1672 47.8476 24.9613C47.8476 26.7554 46.9041 28.4067 45.3234 29.2493L31.8521 36.2992C31.091 36.655 30.3299 36.8317 29.5921 36.8317H29.5933ZM29.6143 15.7697C29.2238 15.7697 28.8555 15.8809 28.5106 16.1021C27.7916 16.5164 27.4268 17.1484 27.4268 17.9172V32.0053C27.4268 32.8351 27.7822 33.4776 28.4545 33.8614C29.1665 34.3179 29.9043 34.3401 30.7017 33.9656L44.1121 26.9461C44.8417 26.5576 45.2497 25.8496 45.2497 24.9613C45.2497 24.1468 44.8218 23.4305 44.1039 23.0478L30.6783 16.0237C30.3088 15.8552 29.9546 15.7709 29.6167 15.7709L29.6143 15.7697Z"
        fill="#6B6B6B"
      />
    </g>
    <defs>
      <clipPath id="clip0_818_3002">
        <rect
          width="67.3913"
          height="50"
          fill="white"
          transform="translate(0.804688)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ContentHubVideo;
